export default __webpack_public_path__ + "static/bariol_serif_bold_italic-webfont-3fecbb5635cdc26cf909a64eb09b6426.svg";